import React, { useState, useRef, useEffect } from "react";
import { useLanguage } from "../contexts/LanguageContext";

const languages = [
  { code: "en", name: "English", flag: "/assets/flags/en.png" },
  { code: "sq", name: "Shqip", flag: "/assets/flags/sq.png" },
  { code: "hr", name: "Hrvatski", flag: "/assets/flags/hr.png" },
];

function LanguageSelector() {
  const { language, changeLanguage } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const currentLanguage = languages.find((lang) => lang.code === language) || languages[0];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleLanguageChange = (langCode) => {
    changeLanguage(langCode);
    setIsOpen(false);
  };

  return (
    <div className="dropdown-container" ref={dropdownRef}>
      <div 
        className="selected-language"
        onClick={() => setIsOpen(!isOpen)}
        style={{ cursor: "pointer" }}
      >
        <img
          src={currentLanguage.flag}
          alt="Selected Flag"
          className="language-flag"
          style={{ width: "30px", height: "20px", cursor: "pointer" }}
          onError={(e) => {
            e.target.style.display = "none";
            e.target.nextSibling.style.display = "block";
          }}
        />
        <span className="language-flag-placeholder" style={{ display: "none" }}>
          {currentLanguage.code.toUpperCase()}
        </span>
      </div>
      {isOpen && (
        <div className="language-dropdown">
          {languages.map((lang) => (
            <div
              key={lang.code}
              className={`language-option ${
                lang.code === language ? "active" : ""
              }`}
              onClick={() => handleLanguageChange(lang.code)}
              style={{ cursor: "pointer" }}
            >
              <img
                src={lang.flag}
                alt={lang.name}
                className="language-flag"
                style={{ width: "30px", height: "20px", cursor: "pointer" }}
                onError={(e) => {
                  e.target.style.display = "none";
                  e.target.nextSibling.style.display = "block";
                }}
              />
              <span
                className="language-flag-placeholder"
                style={{ display: "none" }}
              >
                {lang.code.toUpperCase()}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default LanguageSelector;

